<template>
  <div>
    <el-form class="entrance-exam-form" label-position="top">
      <div class="row">
        <div class="col-md-6">
          <el-form-item label="Trung tâm" required>
            <el-select
              :value="centerId"
              class="w-100 entrance-exam-select"
              :class="{ 'is-filled': centerId }"
              placeholder="Chọn trung tâm"
              :disabled="disabledCenter"
              filterable
              popper-class="entrance-exam-select-dropdown"
              @input="onCenterChange"
            >
              <el-option
                v-for="item in centers"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="col-md-6">
          <el-form-item label="Dự đoán trình độ" required>
            <el-select
              :value="predictedLevel"
              class="w-100 entrance-exam-select"
              :class="{ 'is-filled': predictedLevel }"
              placeholder="Chọn trình độ"
              :disabled="disabledPredictedLevel"
              filterable
              popper-class="entrance-exam-select-dropdown"
              @input="onLevelChange"
            >
              <el-option label="Basic" :value="PREDICTED_LEVEL_BASIC" />
              <el-option label="Cao hơn Basic" :value="PREDICTED_LEVEL_HIGHER" />
            </el-select>
          </el-form-item>
        </div>
      </div>
    </el-form>

    <div v-if="showExamFields" class="schedule-entrance-test-dialog__notice mb-4">
      <i class="el-icon-info"></i>
      <span>
        Học viên cần tham gia Thi đầu khóa gồm các kỹ năng: Ngữ pháp, Nghe, Đọc, Viết, Nói. Vui lòng chọn lịch thi phù hợp.
        <br>
        Lưu ý: Nếu học viên đã có kết quả Ngữ pháp trước đó, hệ thống sẽ tự động bỏ qua kỹ năng này.
      </span>
    </div>

    <entrance-exam-date-time-fields
      v-if="showExamFields"
      ref="examFields"
      :center-id="centerId"
      @state-change="onExamStateChange"
    />
  </div>
</template>

<script>
import EntranceExamDateTimeFields from "./EntranceExamDateTimeFields.vue";

export const PREDICTED_LEVEL_BASIC = "basic";
export const PREDICTED_LEVEL_HIGHER = "higher_basic";

export default {
  name: "SchedulePredictedLevelStep",
  components: {
    EntranceExamDateTimeFields
  },
  props: {
    centers: {
      type: Array,
      default: () => []
    },
    centerId: {
      default: null
    },
    predictedLevel: {
      default: null
    },
    disabledCenter: {
      type: Boolean,
      default: false
    },
    disabledPredictedLevel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      PREDICTED_LEVEL_BASIC,
      PREDICTED_LEVEL_HIGHER
    };
  },
  computed: {
    showExamFields() {
      return this.predictedLevel === PREDICTED_LEVEL_HIGHER;
    }
  },
  methods: {
    onCenterChange(val) {
      this.$emit("update:centerId", val);
      this.$emit("update:predictedLevel", null);
    },
    onLevelChange(val) {
      this.$emit("update:predictedLevel", val);
    },
    onExamStateChange(state) {
      this.$emit("exam-state-change", state);
    },
    validateExam() {
      if (!this.showExamFields) {
        return Promise.resolve(true);
      }
      if (!this.$refs.examFields) {
        return Promise.resolve(false);
      }
      return this.$refs.examFields.validateForm();
    }
  }
};
</script>

